import styled from 'styled-components';

export const Container = styled.div`
  font-size: 20px;
  color: #3a3a3c;
  margin-bottom: 24px;
`;
